import { ComponentPropsWithoutRef, ReactElement } from 'react';
import { IonButtons } from '@ionic/react';
import SignupIcon from '../../../../../assets/icons/SignupIcon';
import classnames from 'classnames';
import useModalRouter from '../../../../../common/hooks/useModalRouter';
import { Modals } from '../../../../../exports/Enums';
import Button from '../../../../../components/buttons/Button';
import Theme from '../../../../../../../components-library/Theme';
import { useTranslation } from 'react-i18next';

type AuthButtonsProps = ComponentPropsWithoutRef<typeof IonButtons>;

const AuthButtons = ({ className, ...rest }: AuthButtonsProps): ReactElement => {
  const { openModal } = useModalRouter();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Home:Components:AuthButtons' });

  return (
    <>
      <IonButtons className={classnames('flex flex-col gap-y-sm', className)} {...rest}>
        <Button
          icon={<SignupIcon className="size-5" color={Theme.color.white.DEFAULT} />}
          onClick={() =>
            openModal({
              id: Modals.Signup,
            })
          }
          title={t('buttons.signup')}
        />
        <Button onClick={() => openModal({ id: Modals.Login })} title={t('buttons.login')} design="tertiary" />
      </IonButtons>
    </>
  );
};

export default AuthButtons;
